import { apiApp } from "/src/config/api";

const endpoint = "admin/users";

const getUserList = params => apiApp.get(endpoint, { params });
const getUserDetail = uid => apiApp.get(endpoint + "/" + uid);
const getUserELiving = uid => apiApp.get(endpoint + "/" + uid + "/e-living");

export { getUserList, getUserDetail, getUserELiving };
